import { batch, shallowEqual, useDispatch as useAppDispatch, useSelector as useAppSelector } from "react-redux";
import { persistStore } from "redux-persist";
import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
// utils
import apiSlice from "src/utils/api-slice";
//
import { setError } from "./slices/error";
import persistedReducer from "./root-reducer";

// ----------------------------------------------------------------------

const listenerMiddleware = createListenerMiddleware();

const errorMiddleware = (store) => (next) => (action) => {
    if (( action?.type ?? "" ).endsWith("/rejected")) {
        const { data } = action?.payload || {};

        store.dispatch(setError(data));
    }

    return next(action);
};

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
        .prepend(listenerMiddleware.middleware)
        .concat(apiSlice.middleware, errorMiddleware)
});

const persistor = persistStore(store);

const { dispatch } = store;

const useSelector = useAppSelector;

const useDispatch = () => useAppDispatch();

export { batch, shallowEqual, dispatch, persistor, store, useDispatch, useSelector };
